// lib/verlaengerung.js
//
// Kurzzeichen für Verlängerungen hinter einem Ergebnis (21.10.2026), Abschrift
// von kurzzeichen() in backend/utils/verlaengerung.js. Der Zähler steht in
// kaempfe.verlaengerungen. backend/utils/__tests__/verlaengerung.test.js
// vergleicht beide bei jedem `npm test`.

function zaehlerAus(v) {
  const n = Math.trunc(Number(v));
  if (!Number.isFinite(n) || n < 0) return 0;
  return Math.min(255, n);
}

/**
 * Kurzzeichen hinter dem Ergebnis (seit 25.10.2026 mit Siegart):
 *   golden_point          → „GP“  (Goldener Punkt; zählt als Verlängerung)
 *   kampfrichterentscheid → „KE“  (Kampfrichterentscheid, auch nach Verlängerung)
 *   sonst mit Verlängerung → „n. V.“, ab 2 „n. 2. V.“; ohne → ''
 */
function kurzzeichen(n, winMethod) {
  if (winMethod === 'golden_point') return 'GP';
  if (winMethod === 'kampfrichterentscheid') return 'KE';
  const z = zaehlerAus(n);
  if (!z) return '';
  return z === 1 ? 'n. V.' : `n. ${z}. V.`;
}

/** Langtext zum Kurzzeichen (Legende, title) */
const KURZZEICHEN_TEXT = { 'GP': 'Goldener Punkt', 'KE': 'Kampfrichterentscheid', 'n. V.': 'nach Verlängerung' };
function kurzzeichenText(k) {
  if (!k) return '';
  return KURZZEICHEN_TEXT[k] || (/^n\. \d+\. V\.$/.test(k) ? `nach ${k.slice(3, -4)} Verlängerungen` : k);
}

module.exports = { zaehlerAus, kurzzeichen, kurzzeichenText };
